// extracted by mini-css-extract-plugin
export var tab = "source_code_tab-module--tab--Ve7HW";